import { AlternateTextType } from 'components/shared/AlternateBoldText';

export const COPY = {
  header: 'Welcome to {{trading_name}}',
  body: "If you would like a no-obligation quote, we just need some basic information from you. Click the 'Enquiring about a job' ",
  subheading1: '',
};

export const BODY_TEXTS: AlternateTextType[] = [
  {
    text: 'If you would like to talk to us about having some work done, and to receive a no-obligation quote, we just need some basic information from you. Click the',
    type: 'normal',
  },
  {
    text: "'Enquiring about a job'",
    type: 'alternate',
  },
  {
    text: 'button below to get started.',
    type: 'normal',
  },
];

export const SUBBODY_TEXTS: AlternateTextType[] = [
  {
    text: 'We have also partnered with Ideal4Finance to be able to offer you finance for your purchases. If you already have a quote from us and want to apply for finance for your quote, instead click the',
    type: 'normal',
  },
  {
    text: "'I already have a quote'",
    type: 'alternate',
  },
  {
    text: 'button below.',
    type: 'normal',
  },
];
